.form-subtitle {
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

.form-field-label {
  width: var(--form-field-label-width);
  font-size: var(--body-size);
  padding-top: var(--spacer);
  display: inline-table;
}

.line {
  font-family: "Roboto-Regular", "Roboto", sans-serif;
  color: var(--main-titles-inputs-600);
  padding-top: 5px;
}

#general-update-product-reboot-day-at {
  font-family: "Roboto-Regular", "Roboto", sans-serif;
  color: var(--main-titles-inputs-600);
  font-size: var(--body-size);
  margin-bottom: 13px;
}

#general-update-ring-field {
  margin-bottom: 120px;
}

.second-title {
  font-size: var(--dialog-title-font-size);
  font-weight: 500;
}
